module.exports = __webpack_public_path__ + "static/contact-us-banner-overlay-3b1a434fe356410cbf7c66119895d8b5.png";